import React, { useEffect, useRef, memo, useState } from 'react';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { useHistory, useParams, useRouteMatch, generatePath, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import qs from 'query-string';
import InfiniteScroll from 'react-infinite-scroller';

import { getGameRankMoreList } from '../../../../actions/game';
import styles from './RankMoreGame.module.less';
import GRLinkCard from '../../../../components/LineCard/GRLinkCard';
import { logging, logPostInfo } from '../../../../actions/log';

const selectGameInfo = createSelector(
  state => state.game,
  game => ({
    rankMoreList: game.rankMoreList || {},
  }),
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const location = useLocation();
  const search = qs.parse(location.search) || {};
  const {
    rankMoreList: { list = [], loading, count, desc },
  } = useSelector(selectGameInfo);
  const logInfoData = useSelector(selectLogInfo);
  const [node, setNode] = useState(null);
  const [initTime, setInitTime] = useState(Date.now());

  useEffect(() => {
    dispatch(
      getGameRankMoreList({
        code: search.code,
        limit: 10,
        skip: 0,
        refresh: true,
      }),
    );
  }, []);

  useEffect(() => {
    setInitTime(Date.now());
  }, []);
  useActivate(() => {
    setInitTime(Date.now());
  });

  const getPVLog = () => {
    dispatch(
      logging({
        category: 'P',
        action: 'Game_Rank_More',
        label: '',
        param2: {
          source: 'Game_Rank_More',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Game_Rank_More',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };
  useEffect(() => {
    getPVLog();
  }, []);

  useActivate(() => {
    getPVLog();
  });

  const getUVlog = () => {
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: 'Game_Rank_More',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          time: Math.ceil(Date.now() - initTime),
        },
      }),
    );
  };

  useEffect(() => {
    return () => {
      getUVlog();
    };
  }, []);
  useUnactivate(() => {
    getUVlog();
  });

  const loadMore = () => {
    dispatch(
      getGameRankMoreList({
        code: search.code,
        limit: 10,
        skip: list.length,
        refresh: false,
      }),
    );
  };

  return (
    <div className={styles.page} ref={r => setNode(r)}>
      <div className={styles.page_container}>
        <div className="title">{desc}</div>
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMore}
          hasMore={list?.length < count}
          loader={
            <div className="loader" key={0}>
              --加载中--
            </div>
          }
          initialLoad={true}
          useWindow={false}
          getScrollParent={() => node}
        >
          {list?.length > 0 && (
            <>
              {list.map((soft, index) => (
                <GRLinkCard key={index} soft={soft} />
              ))}
            </>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
});
